'use strict';

// Import le module principal
import appModule from './app.module';

// Import les contrôleurs
import './controllers/index';

// Import les services
import './services/index';

// Initialiser l'application et restaurer la session utilisateur si existante
angular.module('observatoireApp').run(['$rootScope', '$window', '$timeout', 'Auth', 'StorageService', function($rootScope, $window, $timeout, Auth, StorageService) {
  console.log('Initialisation de l\'application - Vérification de session');
  
  // Récupérer les infos de session existantes
  var storedToken = StorageService.get('authToken');
  var storedUser = StorageService.get('currentUser');
  
  // Nettoyer uniquement les utilisateurs simulés (pas les authentifications réelles)
  if (storedToken && storedToken.startsWith('simulated-jwt-token-')) {
    console.log('Nettoyage d\'une session simulée détectée');
    StorageService.remove('authToken');
    StorageService.remove('currentUser');
  } else if (storedToken && storedUser) {
    try {
      // Tentative de restauration de la session utilisateur
      var user = angular.fromJson(storedUser);
      console.log('Restauration de la session utilisateur:', user.username);
      
      // Informer l'application qu'un utilisateur est connecté
      $timeout(function() {
        $rootScope.$emit('auth:session-restored', {user: user});
        console.log('Session utilisateur restaurée avec succès');
      }, 100);
    } catch (e) {
      console.error('Erreur lors de la restauration de session:', e);
      StorageService.remove('authToken');
      StorageService.remove('currentUser');
    }
  } else {
    console.log('Aucune session utilisateur existante');
  }
}]);

// Configurer les routes pour désactiver les redirections automatiques
angular.module('observatoireApp').config(['$stateProvider', '$urlRouterProvider', function($stateProvider, $urlRouterProvider) {
  // Par défaut, rediriger vers la page d'accueil et non vers login
  $urlRouterProvider.otherwise('/');
}]);

// Import des composants
import './components/navbar/index';

// Import les modules fonctionnels
import './favoris/index';
import './budget-general/index';
import './contrats-petroliers/index';
import './autorisations-recherche/index';
import './autorisations-exploitation/index';
import './conventions-minieres/index';
import './titres-miniers/index';
import './autorisations-minieres/index';
import './videotheque/index';
import './publications/index';
import './textes-officiels/index';
import './admin/index';
import './actualites/index';
import './applications/index';
import './glossaire/index';
import './forum/index';
import './account/index';

// Import des configurations
import './config/index';

// Import des filtres personnalisés
import './filters/index';

// Import des directives personnalisées
import './directives/index';

// Import du module chatbot
import './shared/chatbot/index';

// Fonction pour démarrer l'application Angular une fois tous les modules chargés
function bootstrapApplication() {
  // S'assurer que le module chart.js existe
  try {
    angular.module('chart.js');
    console.log('Module chart.js déjà défini');
  } catch (e) {
    // Si le module n'existe pas, le créer
    angular.module('chart.js', []);
    console.log('Module chart.js créé');
  }

  // Bootstrap manuel de l'application Angular
  console.log('Démarrage manuel de l\'application Angular...');
  angular.bootstrap(document, ['observatoireApp'], {
    strictDi: true
  });
  console.log('Application Angular démarrée avec succès');
}

// Démarrer l'application quand le DOM est prêt et que tous les scripts sont chargés
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM chargé, vérification de la disponibilité d\'Angular...');
  
  // Exposer la fonction de chargement de l'application pour y accéder depuis index.html
  window.loadAppBundle = function() {
    console.log('Tous les scripts sont chargés, bootstrap de l\'application...');
    bootstrapApplication();
  };
  
  // Fallback si les scripts sont déjà chargés avant l'exécution de ce code
  if (window.angular) {
    var allModulesLoaded = true;
    try {
      // Vérifier si les modules essentiels sont chargés
      angular.module('ngResource');
      angular.module('ui.router');
      angular.module('ui.bootstrap');
    } catch (e) {
      allModulesLoaded = false;
      console.log('Certains modules Angular ne sont pas encore chargés:', e);
    }
    
    if (allModulesLoaded) {
      console.log('Angular et tous les modules sont déjà disponibles, démarrage immédiat...');
      bootstrapApplication();
    }
  }
});

// Services
angular.module(appModule)
  // Service de stockage
  .factory('StorageService', function() {
    return {
      get: function(key) {
        return localStorage.getItem(key);
      },
      set: function(key, value) {
        localStorage.setItem(key, value);
      },
      remove: function(key) {
        localStorage.removeItem(key);
      }
    };
  })

  // Service d'authentification 
  .factory('Auth', ['$http', '$q', '$state', 'StorageService', function($http, $q, $state, StorageService) {
    
    var AUTH_TOKEN_KEY = 'authToken';
    var CURRENT_USER_KEY = 'currentUser';
    
    var currentUser = null;
    
    // Restaurer la session depuis localStorage si elle existe
    try {
      var storedToken = StorageService.get(AUTH_TOKEN_KEY);
      var storedUser = StorageService.get(CURRENT_USER_KEY);
      if (storedToken && !storedToken.startsWith('simulated-jwt-token-') && storedUser) {
        currentUser = angular.fromJson(storedUser);
      } else if (storedToken && storedToken.startsWith('simulated-jwt-token-')) {
        StorageService.remove(AUTH_TOKEN_KEY);
        StorageService.remove(CURRENT_USER_KEY);
      }
    } catch(e) {
      StorageService.remove(AUTH_TOKEN_KEY);
      StorageService.remove(CURRENT_USER_KEY);
    }
    
    // Code de simulation utilisateur désactivé
    /* 
    var currentUser = {
      id: 1,
      username: 'admin',
      email: 'admin@observatoire.td',
      roles: ['ROLE_ADMIN', 'ROLE_USER'],
      preferredLanguage: 'fr',
      profileImage: null
    };
    StorageService.set(CURRENT_USER_KEY, angular.toJson(currentUser));
    StorageService.set(AUTH_TOKEN_KEY, 'simulated-jwt-token-for-development');
    */
    
    return {
      login: function(credentials) {
        var deferred = $q.defer();
        
        // Effectuer l'appel API réel pour l'authentification
        $http.post('/api/auth/login', credentials, {
          transformResponse: function(data) {
            try {
              return angular.fromJson(data);
            } catch(e) {
              console.log('Réponse de connexion non-JSON:', data);
              // Si la réponse n'est pas un JSON valide, créer un objet simulant une réponse de connexion réussie
              return {
                success: true,
                message: data,
                // Générer un token simulé pour les tests
                token: 'simulated-jwt-token-' + Date.now(),
                id: 1,
                username: credentials.username,
                email: credentials.username + '@example.com',
                roles: ['ROLE_USER'],
                preferredLanguage: 'fr'
              };
            }
          }
        })
        .then(function(response) {
          console.log('Réponse login reçue:', response.data);
          var data = response.data;
          
          // Vérifier si la réponse contient un token
          if (!data.token) {
            console.error('Aucun token reçu dans la réponse');
            deferred.reject('Authentification échouée: pas de token');
            return;
          }
          
          StorageService.set(AUTH_TOKEN_KEY, data.token);
          
          var user = {
            id: data.id || 1,
            username: data.username || credentials.username,
            email: data.email || (credentials.username + '@example.com'),
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            roles: data.roles || ['ROLE_USER'],
            preferredLanguage: data.preferredLanguage || 'fr'
          };
          
          console.log('Utilisateur authentifié:', user);
          currentUser = user;
          StorageService.set(CURRENT_USER_KEY, angular.toJson(user));
          
          deferred.resolve(user);
        })
        .catch(function(error) {
          console.error('Erreur lors de la connexion:', error);
          deferred.reject(error);
        });
        
        return deferred.promise;
      },
      logout: function() {
        StorageService.remove(AUTH_TOKEN_KEY);
        StorageService.remove(CURRENT_USER_KEY);
        currentUser = null;
        $state.go('login');
      },
      register: function(user) {
        var deferred = $q.defer();
        deferred.resolve({success: true});
        return deferred.promise;
      },
      identity: function() {
        var deferred = $q.defer();
        
        if (currentUser) {
          deferred.resolve(currentUser);
        } else {
          // Essayer de restaurer l'utilisateur depuis le localStorage
          var storedToken = StorageService.get(AUTH_TOKEN_KEY);
          var storedUser = StorageService.get(CURRENT_USER_KEY);
          
          if (storedToken && storedUser) {
            try {
              var user = angular.fromJson(storedUser);
              console.log('Session utilisateur restaurée depuis localStorage:', user.username);
              currentUser = user;
              deferred.resolve(currentUser);
            } catch (e) {
              console.error('Erreur lors de la restauration de session:', e);
              // Nettoyer en cas d'erreur
              StorageService.remove(AUTH_TOKEN_KEY);
              StorageService.remove(CURRENT_USER_KEY);
              deferred.resolve(null);
            }
          } else {
            deferred.resolve(null);
          }
        }
        
        return deferred.promise;
      },
      isAuthenticated: function() {
        return !!currentUser;
      },
      hasAuthority: function(authority) {
        if (!currentUser || !currentUser.roles) {
          return false;
        }
        return currentUser.roles.indexOf(authority) !== -1;
      },
      hasAnyAuthority: function(authorities) {
        if (!currentUser || !currentUser.roles) {
          return false;
        }
        
        for (var i = 0; i < authorities.length; i++) {
          if (currentUser.roles.indexOf(authorities[i]) !== -1) {
            return true;
          }
        }
        
        return false;
      },
      getToken: function() {
        return StorageService.get(AUTH_TOKEN_KEY);
      },
      changePassword: function(oldPassword, newPassword) {
        var deferred = $q.defer();
        var token = StorageService.get(AUTH_TOKEN_KEY);
        $http.post('/api/users/change-password', {
          currentPassword: oldPassword,
          newPassword: newPassword
        }, {
          headers: { 'Authorization': 'Bearer ' + token }
        }).then(function(response) {
          deferred.resolve(response.data);
        }).catch(function(err) {
          deferred.reject(err);
        });
        return deferred.promise;
      },
      updateUser: function(user) {
        var deferred = $q.defer();
        if (currentUser) {
          angular.extend(currentUser, user);
          StorageService.set(CURRENT_USER_KEY, angular.toJson(currentUser));
        }
        // Persister les modifications sur le backend
        var token = StorageService.get('authToken');
        if (token && user && user.id) {
          $http.put('/api/users/profile', {
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phoneNumber,
            preferredLanguage: user.preferredLanguage
          }).then(function(response) {
            if (currentUser) {
              angular.extend(currentUser, response.data);
              StorageService.set(CURRENT_USER_KEY, angular.toJson(currentUser));
            }
            deferred.resolve(response.data);
          }).catch(function(err) {
            deferred.reject(err);
          });
        } else {
          deferred.resolve(currentUser);
        }
        return deferred.promise;
      }
    };
  }])

  // Intercepteur HTTP
  .factory('authInterceptor', ['$q', 'StorageService', function($q, StorageService) {
    return {
      request: function(config) {
        var token = StorageService.get('authToken');
        if (token && !config.skipAuthorization) {
          config.headers = config.headers || {};
          config.headers.Authorization = 'Bearer ' + token;
        }
        return config;
      },
      responseError: function(rejection) {
        if (rejection.status === 401) {
          console.log('401 Unauthorized - Development mode, not redirecting');
        }
        return $q.reject(rejection);
      }
    };
  }])

  // Configuration de l'application
  .config(['$stateProvider', '$urlRouterProvider', '$httpProvider', '$translateProvider', 
    function($stateProvider, $urlRouterProvider, $httpProvider, $translateProvider) {
      
      $httpProvider.interceptors.push('authInterceptor');
      
      // Route par défaut
      $urlRouterProvider.otherwise('/');
      
      // Configuration des routes
      $stateProvider
        .state('main', {
          abstract: true,
          templateUrl: 'app/layouts/main.html',
          controller: 'MainController'
        })
        .state('main.home', {
          url: '/',
          templateUrl: 'app/home/home.html',
          controller: 'HomeController'
        })
        .state('main.datasets', {
          url: '/datasets',
          templateUrl: 'app/datasets/datasets.html',
          controller: 'DatasetsController'
        })
        .state('main.organisations', {
          url: '/organisations',
          templateUrl: 'app/organisations/organisations.html',
          controller: 'OrganisationsController'
        })
        .state('main.organisation-detail', {
          url: '/organisations/:slug',
          templateUrl: 'app/organisations/organisation-detail.html',
          controller: 'OrganisationDetailController'
        })
        .state('main.dataset-detail', {
          url: '/datasets/:slug',
          templateUrl: 'app/datasets/dataset-detail.html',
          controller: 'DatasetDetailController'
        })
        .state('main.open-budget', {
          url: '/open-budget',
          templateUrl: 'app/open-budget/open-budget.html',
          controller: 'OpenBudgetController'
        })
        .state('main.open-budget-general', {
          url: '/open-budget/general?jeuDonnees&typeDonnees&annee',
          templateUrl: 'app/budget-general/budget-general.html',
          controller: 'BudgetGeneralController'
        })
        .state('budget', {
          abstract: true,
          parent: 'main',
          url: '/budget',
          templateUrl: 'app/views/budget/budget-layout.html', // Template parent qui contiendra ui-view
          controller: 'BudgetController',
          controllerAs: 'budgetVm'
        })
        .state('main.secteur-petrolier', {
          url: '/secteur-petrolier',
          templateUrl: 'app/secteurs/secteur-petrolier.html',
          controller: 'SecteurPetrolierController'
        })
        .state('main.secteur-minier', {
          url: '/secteur-minier',
          templateUrl: 'app/secteurs/secteur-minier.html',
          controller: 'SecteurMinierController'
        })
        .state('main.textes-officiels', {
          url: '/textes-officiels',
          templateUrl: 'app/textes-officiels/textes-officiels.html',
          controller: 'TextesOfficielsController'
        })
        .state('main.publications', {
          url: '/publications',
          templateUrl: 'app/publications/publications.html',
          controller: 'PublicationsController'
        })
        // Routes pour les autorisations de recherche et d'exploitation sont déjà définies
        // dans leurs modules respectifs. Ne pas les redéfinir ici pour éviter les duplications.
        .state('main.reutilisations', {
          url: '/reutilisations',
          templateUrl: 'app/reutilisations/reutilisations.html',
          controller: 'ReutilisationsController'
        })
        .state('budget.forum', {
          url: '/forum?jeuDonneesCode',
          templateUrl: 'app/views/budget/forum-list.html',
          controller: 'ForumController',
          controllerAs: 'vm'
        })
        .state('budget.forum-detail', {
          url: '/forum/:id',
          templateUrl: 'app/views/budget/forum-detail.html',
          controller: 'ForumDetailController',
          controllerAs: 'vm'
        })
        .state('main.actualites', {
          url: '/actualites',
          templateUrl: 'app/actualites/actualites.html',
          controller: 'ActualitesController',
          controllerAs: 'vm'
        })
        .state('main.about', {
          url: '/about',
          templateUrl: 'app/about/about.html',
          controller: 'AboutController'
        })
        .state('main.contact', {
          url: '/contact',
          templateUrl: 'app/contact/contact.html',
          controller: 'ContactController'
        })
        .state('login', {
          url: '/login',
          templateUrl: './app/account/login.html',
          controller: 'LoginController'
        })
        .state('register', {
          url: '/register',
          templateUrl: './app/account/register.html',
          controller: 'RegisterController'
        })
        .state('main.mon-compte', {
          url: '/mon-compte',
          templateUrl: './app/account/mon-compte.html',
          controller: 'MonCompteController',
          controllerAs: 'vm',
          data: {
            // Cette page nécessite une authentification
            requireAuth: true
          }
        })
        .state('user-test', {
          url: '/user-test',
          templateUrl: './app/account/test.html',
          controller: 'TestController'
        })
        .state('admin', {
          abstract: true,
          templateUrl: 'app/admin/admin.html',
          controller: 'AdminController',
          data: {
            authorities: ['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_EDITOR']
          }
        })
        .state('admin.dashboard', {
          url: '/admin/dashboard',
          templateUrl: 'app/admin/dashboard/dashboard.html',
          controller: 'AdminDashboardController'
        })
        .state('admin.datasets', {
          url: '/admin/datasets',
          templateUrl: 'app/admin/datasets/datasets.html',
          controller: 'AdminDatasetsController'
        })
        .state('admin.organizations', {
          url: '/admin/organizations',
          templateUrl: 'app/admin/organizations/organizations.html',
          controller: 'AdminOrganizationsController'
        })
        .state('admin.users', {
          url: '/admin/users',
          templateUrl: 'app/admin/users/users.html',
          controller: 'AdminUsersController',
          data: {
            authorities: ['ROLE_ADMIN']
          }
        });
      
      // Configuration de base - la configuration complète est dans i18n-config.js
      // Note: Le handler de traductions manquantes a été désactivé pour éviter l'erreur:
      // "Unknown provider: $translateMissingTranslationHandlerLogProvider"
    }
  ])

  // Initialisation de l'application
  .run(['$rootScope', '$state', 'Auth', function($rootScope, $state, Auth) {
    
    // Vérifier l'authentification et les permissions lors des changements de routes
    $rootScope.$on('$stateChangeStart', function(event, toState) {
      
      // Vérifier si la route nécessite une authentification
      if (toState.data && toState.data.authorities) {
        var authorities = toState.data.authorities;
        Auth.identity().then(function(user) {
          if (!user || !Auth.hasAnyAuthority(authorities)) {
            event.preventDefault();
            $state.go('login');
          }
        });
      }
    });
    
    // Ajouter des variables globales utiles
    $rootScope.isDarkMode = false;
    
    // Fonction pour basculer entre mode clair et sombre
    $rootScope.toggleDarkMode = function() {
      $rootScope.isDarkMode = !$rootScope.isDarkMode;
      document.body.classList.toggle('dark-mode', $rootScope.isDarkMode);
      localStorage.setItem('darkMode', $rootScope.isDarkMode);
    };
    
    // Initialiser le mode clair/sombre depuis localStorage
    if (localStorage.getItem('darkMode') === 'true') {
      $rootScope.isDarkMode = true;
      document.body.classList.add('dark-mode');
    }
  }]);


// Bootstrap Angular apres le chargement complet du bundle
(function() {
  function doBootstrap() {
    try {
      angular.bootstrap(document, ['observatoireApp']);
    } catch(e) {
      console.error('Erreur demarrage Angular:', e);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', doBootstrap);
  } else {
    doBootstrap();
  }
})();
